<template>
  <div class="my-account">
    <plans v-if="$whitelabel !== 'digifarm'"/>
    <system-settings :data="systemSettings" />
    <general-settings :data="generals" />
    <locations :data="location" />
    <change-password :data="changePassword" />
    <account-details />
  </div>
</template>

<script>
import GeneralSettings from '@/components/account/GeneralSettings'
import Locations from '@/components/account/Location'
import ChangePassword from '@/components/account/ChangePassword'
import SystemSettings from '@/components/account/SystemSettings'
import AccountDetails from '@/components/account/AccountDetails'
import Plans from '@/components/account/plans/Plans'

import API from '@/api'
export default {
  data() {
    return {
      generals : {
        firstName : {
          label : this.$ml.get('Full name'),
          type  : 'text',
          value : null
        },
        // lastName : {
        //   label : this.$ml.get(`Last Name`),
        //   type  : 'text',
        //   value : null
        // },
        email : {
          label : this.$ml.get(`Email`),
          type  : 'email',
          value : null,
          disabled: true,
        },
        companyName : {
          label : this.$ml.get(`Company Name`),
          type  : 'text',
          value : null
        },
        phone : {
          label : this.$ml.get(`Phone`),
          type  : 'tel',
          value : null,
          minlength : 5,
        },
      },
      location : {
        country : {
          label : this.$ml.get(`Country`),
          type  : 'text',
          value : null
        },
        state : {
          label : this.$ml.get(`State`),
          type  : 'text',
          value : null
        },
        city : {
          label : this.$ml.get(`City`),
          type  : 'text',
          value : null
        },
        address : {
          label : this.$ml.get(`Address`),
          type  : 'text',
          value : null
        },
        zipCode : {
          label : this.$ml.get(`ZIP-code`),
          type  : 'text',
          value : null
        },
      },
      changePassword : {
        oldPass : null,
        newPass : null,
        confirmNewPass : null,
      },
      systemSettings : {
        language : {
          label : this.$ml.get(`Language`),
          type  : 'text',
          value : null
        },
        // dateFormat : {
        //   label : 'Date Format',
        //   type : 'text',
        //   value : null
        // },
        // units : {
        //   label : 'Units Format',
        //   type : 'text',
        //   value : null
        // },
        // currency : {
        //   label : 'Currency',
        //   type : 'text',
        //   value : null
        // }
      }
    }
  },
  created() {
    this.init();
  },
  components : {
    GeneralSettings,
    Locations,
    ChangePassword,
    SystemSettings,
    AccountDetails,
    Plans,

  },
  methods : {
    init() {

      const user = this.$store.getters['user/data'];

      this.generals.email.value = user.email;
      this.generals.firstName.value = user.firstName;
      // this.generals.lastName.value = user.lastName;
      this.generals.phone.value = user.phone;
      this.generals.companyName.value = user.company;
      this.location.country.label = user.country;
      this.location.country.value = user.country;
      this.location.state.value = user.state;
      this.location.address.value = user.address;
      this.location.zipCode.value = user.zip;
      this.location.city.value = user.city;

      this.systemSettings.language.value = user.language;
    },
  },
}
</script>

<style lang="scss" scoped>
.my-account {
  background-color: #fff;
  border: 1px solid #E4E5E6;
  border-radius: 5px;
  padding: 8px 32px;
  min-height: 200px;
  .account-row {
    margin-bottom: 32px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;

    &::v-deep {
      h2 {
        margin-top:0px;
        margin-bottom: 0;
      }
      .heading {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 24px 0 24px;
        h2 {
          // margin-right: 16px;
        }
        button, a {
          margin: 0  0 0 16px;
        }
        // button {
        //   // margin-top: 16px;
        //   font-size: 18px;
        //   padding: 0;
        //   margin: 0 16px;
        //   border-width: 0;
        //   text-transform: capitalize;
        //   &:hover {
        //     background-color: #fff;
        //     color: #4F8239;
        //   }

        // }
      }
      form {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-right: -8px;
        margin-left: -8px;
        .text-input {
          flex-basis: calc(33% - 16px);
          margin-bottom: 8px;
          margin-top: 24px;
          margin-right: 8px;
          margin-left: 8px;
        }
      }
      // button {
      //   // margin-top: 16px;
      //   font-size: 18px;
      //   padding: 0;
      //   margin: 0 16px;
      //   border-width: 0;
      //   text-transform: capitalize;
      //   &:hover {
      //     background-color: #fff;
      //     color: #4F8239;
      //   }

      // }
      @media(max-width:768px) {
        form {
          margin-right: 0;
          margin-left: 0;
          .text-input {
            margin-right: 0;
            margin-left: 0;
          }
        }
        .heading {
          flex-direction: column;
          width: 100%;
          button {
            margin-left: 0;
            margin-top: 8px;
          }
        }
      }
    }

  }
}
@media (max-width:900px) {
  .my-account {
    padding: 16px 8px;
    .account-row {
      &::v-deep {
        form {
          flex-direction: column;
        }
      }
    }
  }
}
body[dir="rtl"] {
  .my-account {

  }
}
</style>
